import { CountryActionTypes } from "./constants";

export const changeCountry = (countryCode: string = "ic") => ({
  type: CountryActionTypes.CHANGE_COUNTRY,
  payload: countryCode,
});

export const updateCountry = (
  countryCode: string,
  countryName: string,
  countryFlag: any
) => ({
  type: CountryActionTypes.UPDATE_COUNTRY,
  payload: {
    code: countryCode,
    name: countryName,
    flag: countryFlag,
  },
});
